import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This component is used to display a badge on a merch card.
 *
 * @param translationKey - The translation key to display on the badge. This should be a valid i18n key.
 * @param badgeColor - The color of the badge. Defaults to 'fill-primary-default'.
 * @param link - The link to display on the badge.
 * @param isAppAuth - Whether the user is authenticated. Defaults to false.
 * @returns The badge component.
 */
export const MerchCardBadge = ({
  translationKey,
  badgeColor = 'fill-primary-default',
  borderColor,
  textColor = 'text-core-on-fill-default',
  link
}) => {
  const isValidTranslationKey = isValidI18nKey(translationKey);
  if (!isValidTranslationKey) {
    console.warn(`Invalid translation key: ${translationKey}`);
    return null;
  }
  const hasBorder = !!borderColor;
  let badgeText = /*#__PURE__*/_jsx(Text, {
    typography: "heading-25",
    color: textColor,
    textAlign: "center",
    truncate: true,
    paddingInline: "200",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationKey
    })
  });
  if (link) {
    badgeText = /*#__PURE__*/_jsx(Link, {
      href: link,
      hideExternalLinkIcon: true,
      underline: false,
      children: badgeText
    });
  }
  return /*#__PURE__*/_jsx(View, {
    position: "absolute",
    insetBlockStart: "-24px",
    insetBlockEnd: "0",
    insetInlineStart: "0",
    insetInlineEnd: "0",
    borderColor: borderColor,
    borderStyle: hasBorder ? 'solid' : 'none',
    borderWidth: hasBorder ? '200' : '0',
    borderStartStartRadius: "300",
    borderStartEndRadius: "300",
    paddingBlock: hasBorder ? '50' : '100',
    backgroundColor: badgeColor,
    children: badgeText
  });
};